import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext'

const LockedOrganizationDialog = () => {
  const navigate = useNavigate()
  const { currentUser: { selfOrganizations } } = useAuth()
  const { lockedOrganizationDialog, lockedOrganizationName, closeLockedOrganizationDialog } = useGlobalContext()

  const unlockedOrganizations = selfOrganizations?.filter(org => !org.locked) || []

  const handleClose = () => {
    closeLockedOrganizationDialog()
    navigate('/management/profile')
  }

  return (
    <Dialog
      open={lockedOrganizationDialog}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="locked-organization-dialog-title"
        variant="h5"
        sx={{ color: 'error.main' }}
      >
        {t('organizations.organizationBlocked')}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" paragraph>
          {t('organizations.error.lockedWithHelpdesk', { organizationName: lockedOrganizationName })}
        </Typography>

        {unlockedOrganizations.length > 0 && (
          <Typography variant="body2" color="text.secondary">
            {t('organizations.availableOrganizations', { count: unlockedOrganizations.length })}
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          id="locked-organization-dialog-button-understood"
          onClick={handleClose}
          variant="contained"
          color="primary"
        >
          {t('common.understood')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LockedOrganizationDialog
